import React from 'react';

interface InitialsAvatarProps {
  name?: string | null;
  className?: string;
}

/** First letter of the first two words (e.g. "Umang Arora" -> "UA"); a single
 * word falls back to its first two letters; empty/missing falls back to "U". */
function getInitials(name?: string | null): string {
  const trimmed = (name || '').trim();
  if (!trimmed) return 'U';

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, className = '' }) => {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-agentic-primary-blue to-agentic-accent-purple font-semibold text-white ${className}`}
      aria-hidden
    >
      {getInitials(name)}
    </div>
  );
};

export default InitialsAvatar;
